export default function createMethods(session) {
  return {
    loadFile(vtkFile, initialColorBy) {
      return session.call("swx.proxy.manager.create.reader", [
        vtkFile,
        initialColorBy
      ]);
    },
    resetCamera(viewId = "-1") {
      return session.call("viewport.camera.reset", [viewId]);
    },
    deleteProxy(proxyId) {
      return session.call("pv.proxy.manager.delete", [proxyId]);
    },
    getProxy(proxyId) {
      return session.call("pv.proxy.manager.get", [proxyId]);
    },
    updateVisibility(representationId, isVisible) {
      return session.call("swx.proxy.manager.update.visibility", [
        representationId,
        isVisible ? 1 : 0
      ]);
    },
    updateRepresentation(representationId, representation) {
      return session.call("pv.proxy.manager.update", [
        [
          {
            id: representationId,
            name: "Representation",
            value: representation
          }
        ]
      ]);
    },
    updateColorBy(
      readerId,
      location,
      name,
      componentName,
      vectorMode,
      component
    ) {
      return session.call("swx.color.manager.color.by", [
        readerId,
        "array",
        location,
        name,
        componentName,
        vectorMode,
        component,
        true
      ]);
    },
    invertTransferFunctions(representationId) {
      return session.call("swx.color.manager.invert.transfer.function", [
        representationId
      ]);
    }
  };
}

/**

 pv.color.manager.color.by:
   - params: representation (id do proxy), colorMode: "array", arrayLocation (POINTS), arrayName (StrainX), vectorMode (Magnitude), vectorComponent (-1), rescale (True)
   - ex: ["575","array","POINTS","Displacement","Magnitude",-1,true]
   - ex: ["575","array","CELLS","AvStressZ","Magnitude",-1,true]

 Trocar tipo de dado (avStressY => para outro)


 pv.proxy.manager.update: serve apenas para trocar representação, entao o id ali é um id de um proxy de representation!!!

 Trocar representação, (Feature Edges, Surface, etc),

 ex de params: [{'id': '573', 'name': 'Representation', 'value': 'Points'}]
 ex de params para mudar a visibilidade: [{'id': '573', 'name': 'Visibility', 'value': 1}] (value = 1 é visivel, 0 otherwide)

 */
